import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LocalizePipe } from '@shared/pipes/localize.pipe';
import { EnumOptionsPipe } from '@shared/pipes/enum-options.pipe';

import { AbpPaginationControlsComponent } from './components/organisms/pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './components/organisms/validation/abp-validation.summary.component';
import { AbpModalFooterComponent } from './components/organisms/modal/abp-modal-footer.component';
import { LayoutStoreService } from './layout/layout-store.service';
import { DynamicTableComponent } from './components/organisms/dynamic-table/dynamic-table.component';
import { DynamicFilterComponent } from './components/organisms/dynamic-table/dynamic-filter.component';
import { SpinnerComponent } from './components/atoms/spinner/spinner.component';
import { BadgeComponent } from './components/atoms/badge/badge.component';
import { EmptyStateComponent } from './components/atoms/empty-state/empty-state.component';
import { SelectComponent } from './components/atoms/select/select.component';
import { FormFieldComponent } from './components/molecules/form-field/form-field.component';
import { InfoItemComponent } from './components/atoms/info-item/info-item.component';
import { InfoCardComponent } from './components/molecules/info-card/info-card.component';
import { RowsSectionComponent } from './components/molecules/rows-section/rows-section.component';
import { StatRowComponent } from './components/atoms/stat-row/stat-row.component';
import { HeroChipComponent } from './components/atoms/hero-chip/hero-chip.component';
import { ColorSwatchComponent } from './components/atoms/color-swatch/color-swatch.component';
import { ActionsMenuComponent } from './components/atoms/actions-menu/actions-menu.component';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';

import { TableModule } from 'primeng/table';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        FormsModule,
        TableModule,
        PaginatorModule,
        ProgressBarModule,
        AutoCompleteModule,
        DynamicDialogModule,
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        EnumOptionsPipe,
        BusyDirective,
        EqualValidator,
        DynamicTableComponent,
        DynamicFilterComponent,
        SpinnerComponent,
        BadgeComponent,
        EmptyStateComponent,
        SelectComponent,
        FormFieldComponent,
        InfoItemComponent,
        InfoCardComponent,
        RowsSectionComponent,
        StatRowComponent,
        HeroChipComponent,
        ColorSwatchComponent,
        ActionsMenuComponent,
    ],
    exports: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        EnumOptionsPipe,
        BusyDirective,
        EqualValidator,
        FormsModule,
        NgxPaginationModule,
        TableModule,
        PaginatorModule,
        DynamicDialogModule,
        DynamicTableComponent,
        DynamicFilterComponent,
        SpinnerComponent,
        BadgeComponent,
        EmptyStateComponent,
        SelectComponent,
        FormFieldComponent,
        InfoItemComponent,
        InfoCardComponent,
        RowsSectionComponent,
        StatRowComponent,
        HeroChipComponent,
        ColorSwatchComponent,
        ActionsMenuComponent,
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [AppSessionService, AppUrlService, AppAuthService, AppRouteGuard, LayoutStoreService, DialogService],
        };
    }
}
